var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.19 19.75",
    fill: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3745.16,431.763h-11.19a1.165,1.165,0,0,1-1.16-1.167v-17.43a1.165,1.165,0,0,1,1.16-1.168h11.19a1.174,1.174,0,0,1,1.17,1.168v5.4a0.78,0.78,0,0,1-.78.779,0.772,0.772,0,0,1-.77-0.779v-5.009h-10.42v16.649h10.42v-4.987a0.772,0.772,0,0,1,.77-0.779,0.78,0.78,0,0,1,.78.779V430.6A1.173,1.173,0,0,1,3745.16,431.763Zm2.64-5.809a0.779,0.779,0,0,1-.55-1.33l2.86-2.884-2.86-2.892a0.778,0.778,0,0,1,.01-1.1,0.764,0.764,0,0,1,1.09,0l3.41,3.442a0.785,0.785,0,0,1,0,1.1l-3.41,3.434A0.767,0.767,0,0,1,3747.8,425.954Zm2.95-3.438h-12.88a0.779,0.779,0,0,1,0-1.558h12.88A0.779,0.779,0,1,1,3750.75,422.516Z",
    transform: "translate(-3732.81 -412)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3d357617d523b2a5ddae7b89fc9a03dc.svg";
export { ForwardRef as ReactComponent };